import { Component } from 'react';
import { getContentModelId, getTemplatePath, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getTemplateLabel, getHasTemplate, getIsRestorableTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import ContentRoutes from 'ContentUtils/Routes';
import { Referrers } from 'page-creation-lib/constants/Referrers';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module
import ForceTemplateSwapModal from 'ContentEditorUI/components/modals/ForceTemplateSwapModal';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module
import TemplateSelectModal from 'ContentEditorUI/components/modals/TemplateSelectModal';
import { getHasModulesInFlexColumn } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
import { connect } from 'react-redux';
import { bindAll } from 'underscore';
import { fetchTemplateInfo, handleRestoreMissingTemplate
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module
} from 'ContentEditorUI/redux/actions/templateInfoActions';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isMissingTemplate: !getHasTemplate(state),
  messageKey: getTemplatePath(state) ? getTemplateLabel(state) ? 'deletedTemplateMessage' : 'deletedTemplateNoLabelMessage' : 'noTemplateMessage',
  templatePath: getTemplatePath(state),
  contentId: getContentModelId(state),
  hasModulesInFlexColumn: getHasModulesInFlexColumn(state),
  shouldShowRestore: getIsRestorableTemplate(state),
  previewKey: getPreviewKey(state),
  isStagingV2: getIsStagingV2(state)
});
const connector = connect(mapStateToProps, {
  handleRestoreMissingTemplate,
  fetchTemplateInfo
});
export class TemplateExistenceCheckContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForceTemplateSwampModal: props.isMissingTemplate,
      showTemplateSelectModal: false
    };
    bindAll(this, 'onConfirm', 'closeTemplateSelectModal');
  }
  componentDidMount() {
    if (this.props.isMissingTemplate) {
      this.props.fetchTemplateInfo(this.props.templatePath);
    }
  }
  onConfirm() {
    this.setState({
      showForceTemplateSwampModal: false
    });
    const {
      contentType,
      contentId,
      isStagingV2
    } = this.props;
    if (contentType === 'email') {
      this.setState({
        showTemplateSelectModal: true
      });
    } else {
      window.location.href = ContentRoutes.templateSwapWithOptions({
        categoryId: contentType,
        contentId,
        referrer: isStagingV2 ? Referrers.contentStaging : Referrers.pageSettings
      });
    }
  }
  closeTemplateSelectModal() {
    const {
      cancelRedirectUrl
    } = this.props;
    if (cancelRedirectUrl) {
      window.location.href = cancelRedirectUrl;
    }
  }
  render() {
    const {
      messageKey,
      hasModulesInFlexColumn,
      children,
      isCustomTemplateWithFlexArea,
      shouldShowRestore,
      contentType,
      contentId,
      previewKey
    } = this.props;
    const {
      showForceTemplateSwampModal,
      showTemplateSelectModal
    } = this.state;
    if (showForceTemplateSwampModal) {
      return /*#__PURE__*/_jsx(ForceTemplateSwapModal, {
        onConfirm: this.onConfirm,
        messageKey: messageKey,
        hasModulesInFlexColumn: hasModulesInFlexColumn,
        shouldShowRestore: shouldShowRestore,
        onRestore: this.props.handleRestoreMissingTemplate,
        hasDndArea: isCustomTemplateWithFlexArea
      });
    }
    if (showTemplateSelectModal) {
      return /*#__PURE__*/_jsx(TemplateSelectModal, {
        contentType: contentType,
        contentId: contentId,
        onClose: this.closeTemplateSelectModal,
        previewKey: previewKey,
        hasDndArea: isCustomTemplateWithFlexArea
      });
    }
    if (children) {
      return children;
    }
    return null;
  }
}
export default connector(TemplateExistenceCheckContainer);